module.exports = __webpack_public_path__ + "static/media/poste_23.fa3e6bf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_23.jpg
// module id = 252
// module chunks = 0